import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-discard-changes-dialog',
  template: `
    <h1 mat-dialog-title>Descartar cambios</h1>
    <div mat-dialog-content>
      <p>¿Estás seguro de que deseas descartar los cambios?</p>
    </div>
    <div mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="onCancel()">Cancelar</button>
      <button mat-button class="accept-button" (click)="onConfirm()">Aceptar</button>
    </div>
  `,
  styles: [`
    .dialog-actions {
      display: flex;
      justify-content: flex-end;
    }
    .accept-button {
      color: white;
      background-color: red;
    }
  `]
})
export class DiscardChangesDialogComponent {
  constructor(private dialogRef: MatDialogRef<DiscardChangesDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}